/**
 * Converts a UTC date string from the backend to a local Date object.
 * The backend stores all datetimes in UTC but returns them without
 * timezone info (e.g. "2026-02-27T10:30:00"). Without the trailing 'Z',
 * JavaScript's Date constructor treats the value as local time.
 * This helper appends 'Z' when needed so the value is correctly
 * interpreted as UTC and displayed in the browser's local timezone.
 */
export function utcToLocalDate(dateStr) {
    if (!dateStr) return null;
    const s = String(dateStr).trim();
    // If the string already has timezone info, use as-is
    if (s.endsWith('Z') || /[+-]\d{2}:\d{2}$/.test(s)) {
        return new Date(s);
    }
    return new Date(s + 'Z');
}

/**
 * Formats a UTC date string from the backend to the browser's local
 * date/time string using toLocaleString().
 * @param {string} dateStr – ISO datetime string from the API (UTC)
 * @param {Intl.DateTimeFormatOptions} [options] – optional formatting options
 * @returns {string} formatted local date/time string, or '-' if input is falsy
 */
export function formatUtcToLocal(dateStr, options) {
    const d = utcToLocalDate(dateStr);
    if (!d || isNaN(d.getTime())) return '-';
    return options ? d.toLocaleString([], options) : d.toLocaleString();
}
